import { AnyAction } from "redux";
import { SubscriptionStepData, SubscriptionStepsState } from "../../../../../models/state";
import * as CHECKOUT_AT from "../../../checkout/state/actionTypes";
import { fulfilled } from "../../../checkout/utils";
import * as AT from "../actionTypes";

const initialState: SubscriptionStepsState = {};

const getDefaultStepData = (): SubscriptionStepData => ({
    currentStepIndex: 0,
    totalSteps: 3,
    completedSteps: 0,
});

const subscriptionStepsReducer = (state = initialState, action: AnyAction): SubscriptionStepsState => {
    switch (action.type) {
        case fulfilled(CHECKOUT_AT.CHECKOUT_ADD_SUBSCRIPTION_TO_CART): {
            // Initialize step data for any new subscriptions that don't have it yet
            const subscriptions = action.payload?.subscriptions || {};
            const newState = { ...state };
            let hasChanges = false;

            Object.keys(subscriptions).forEach((subscriptionId) => {
                if (!newState[subscriptionId]) {
                    newState[subscriptionId] = getDefaultStepData();
                    hasChanges = true;
                }
            });

            return hasChanges ? newState : state;
        }
        case AT.RETAILER_SET_SUBSCRIPTION_STEP: {
            const { subscriptionId, stepIndex } = action.payload;
            const currentData = state[subscriptionId] || getDefaultStepData();
            return {
                ...state,
                [subscriptionId]: {
                    ...currentData,
                    currentStepIndex: stepIndex,
                    completedSteps: Math.max(currentData.completedSteps, stepIndex),
                },
            };
        }
        case AT.RETAILER_NEXT_SUBSCRIPTION_STEP: {
            const { subscriptionId } = action.payload;
            const currentData = state[subscriptionId] || getDefaultStepData();
            const newStepIndex = Math.min(currentData.currentStepIndex + 1, currentData.totalSteps - 1);
            return {
                ...state,
                [subscriptionId]: {
                    ...currentData,
                    currentStepIndex: newStepIndex,
                    completedSteps: Math.max(currentData.completedSteps, currentData.currentStepIndex + 1),
                },
            };
        }
        case AT.RETAILER_PREV_SUBSCRIPTION_STEP: {
            const { subscriptionId } = action.payload;
            const currentData = state[subscriptionId] || getDefaultStepData();
            return {
                ...state,
                [subscriptionId]: {
                    ...currentData,
                    currentStepIndex: Math.max(currentData.currentStepIndex - 1, 0),
                },
            };
        }
        case AT.RETAILER_SET_COMPLETED_SUBSCRIPTION_STEPS: {
            const { subscriptionId, completedSteps } = action.payload;
            const currentData = state[subscriptionId] || getDefaultStepData();
            return {
                ...state,
                [subscriptionId]: {
                    ...currentData,
                    completedSteps: Math.max(currentData.completedSteps, completedSteps),
                },
            };
        }
        case AT.RETAILER_RESET_SUBSCRIPTION_STEPS: {
            const { subscriptionId } = action.payload;
            const currentData = state[subscriptionId] || getDefaultStepData();
            return {
                ...state,
                [subscriptionId]: {
                    ...currentData,
                    currentStepIndex: 0,
                    completedSteps: 0,
                },
            };
        }
        case AT.RETAILER_SET_IS_ADDING_SUBSCRIPTION: {
            return {
                ...state,
                isAddingSubscription: action.payload.isAddingSubscription,
            };
        }
        default:
            return state;
    }
};

export default subscriptionStepsReducer;
